import React, { useEffect, useState } from 'react';
import Slider from 'react-slick';
import { v4 } from 'uuid';
import { isEmpty } from 'lodash';
import SweetAlert from 'react-bootstrap-sweetalert';
import { Fancybox as FancyBoxNative } from '@fancyapps/ui';
import VehicleImagesPopupSlider from '../VehicleImagesPopupSlider';
import { PhotoPerspective } from '../../../constants/PhotoPerspective';
import warningIcon from '../../../assets/img/Ripple-2.7s-211px.gif';
import iconPoint from '../../../assets/img/grupa11.png';
import { prepareDamagesDescription } from '../../helpers/prepareDamagesDescription';
import { FancyBoxHiddenGallery, fancyBoxOptions } from '../FancyBox';
import { DamageTypesName } from '../../../constants/DamageTypes';
import cameraIcon from '../../../assets/img/icons/camera.svg';
import videoIcon from '../../../assets/img/icons/video.svg';
import { useMediaQuery } from '../../hooks/useMediaQuery';

function ImageSlider({ videos, images, actionButtons }) {
  const isMobile = useMediaQuery('(max-width: 768px)');
  const allMedia = [
    ...images.filter((image) => image?.fileUrl),
    ...videos.filter((video) => video?.fileUrl),
  ];
  const [mainSlide, setMainSlide] = useState(allMedia[0]);
  const [mainSlideIndex, setMainSlideIndex] = useState(0);
  const [showPopup, setShowPopup] = useState(false);
  const [popupInitial, setPopupInitial] = useState(0);

  const settings = {
    dots: false,
    infinite: true,
    speed: 400,
    slidesToShow: 4,
    slidesToScroll: 1,
    focusOnSelect: true,
    variableWidth: true,
    arrows: false,
    afterChange: (index) => {
      setMainSlideIndex(index);
      setMainSlide(allMedia[index]);
    },
  };

  const filteredRequiredPhotos = images?.filter((item) => item?.id);

  useEffect(() => {
    FancyBoxNative.bind(`[data-fancybox="gallery"]`, {
      ...fancyBoxOptions,
      on: {
        done: (fancybox, slide) => {
          // eslint-disable-next-line radix
          if (!parseInt(slide?.damages) || !slide?.id) return;

          const mediaData = allMedia.find((el) => el.id === slide.id);
          if (!mediaData || !mediaData?.damages?.length) return;

          // show damages icon and text over main slider
          const overlayWrapper = document.createElement('div');
          overlayWrapper.style.position = 'absolute';
          overlayWrapper.style.width = '100%';
          overlayWrapper.style.height = '100%';
          overlayWrapper.style.display = 'flex';
          overlayWrapper.style.justifyContent = 'center';
          overlayWrapper.style.alignItems = 'center';

          const damagedTextElement = document.createElement('div');
          damagedTextElement.className = 'photo_gallery_damage_info';

          const damagedTextSpanWrapperElement = document.createElement('span');

          const damagedTextImgElement = document.createElement('img');
          damagedTextImgElement.src = iconPoint;
          damagedTextImgElement.alt = 'Warning icon';
          damagedTextImgElement.className = 'damages__warning-icon';
          damagedTextImgElement.style.width = '16px';
          damagedTextImgElement.style.height = '16px';

          damagedTextSpanWrapperElement.append(
            'Tap ',
            damagedTextImgElement,
            'to see ',
            prepareDamagesDescription(mediaData.damages),
          );

          damagedTextElement.appendChild(damagedTextSpanWrapperElement);

          const damagedButtonElement = document.createElement('button');
          damagedButtonElement.className = 'photo_gallery_damage_button';

          const imgElement = document.createElement('img');
          imgElement.src = warningIcon;
          imgElement.alt = 'Warning icon';
          imgElement.className = 'damages__warning-icon';

          damagedButtonElement.appendChild(imgElement);

          damagedButtonElement.addEventListener('click', (e) => {
            e.preventDefault();
            e.stopPropagation();
            openDamagedGallery(mediaData.damages);
          });

          overlayWrapper.appendChild(damagedButtonElement);
          overlayWrapper.appendChild(damagedTextElement);

          slide.contentEl.appendChild(overlayWrapper);
        },
        shouldClose: (fancybox, event, eventComponent) => {
          if (!eventComponent) {
            event.preventDefault();
          }

          event.stopPropagation();
        },
      },
    });
    return () => {
      FancyBoxNative.unbind(`[data-fancybox="gallery"]`);
      FancyBoxNative.close();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const openDamagedGallery = (damages) => {
    if (damages?.length) {
      FancyBoxNative.show(
        damages?.map((image) => ({
          src: image?.fileUrl,
          caption: DamageTypesName?.[image?.damageType] || '',
        })),
        {
          ...fancyBoxOptions,
          on: {
            shouldClose: (fancybox, event, eventComponent) => {
              if (!eventComponent) {
                event.preventDefault(); // prevent double click
              }

              event.stopPropagation();
            },
          },
        },
      );
    }
  };

  const openGallery = (group, index = 0) => {
    FancyBoxNative.fromSelector(`[data-fancybox="${group}"]`, { startIndex: index });
  };

  return (
    <>
      <div className="common-images-slider">
        <div className="common-images-slider__counters">
          <div className="auction-list-item__image-pill">
            <img src={cameraIcon} alt="Social Media Icon" />
            <span className="image-pill__counter">{images?.length}</span>
          </div>
          {!!videos?.length && (
            <div className="auction-list-item__image-pill">
              <img src={videoIcon} alt="Social Media Icon" />
              <span className="image-pill__counter">{videos?.length}</span>
            </div>
          )}
        </div>
        {isMobile && <div className="action-buttons--mobile">{actionButtons()}</div>}
        <div className="common-images-slider__main-image">
          {mainSlide.perspective !== PhotoPerspective.MASTER &&
            !isEmpty(mainSlide?.damages) && (
              <>
                <button
                  type="button"
                  className="photo_gallery_damage_button"
                  onClick={() => {
                    openDamagedGallery(mainSlide?.damages);
                  }}
                >
                  <img
                    className="damages__warning-icon"
                    src={warningIcon}
                    alt="Warning icon"
                  />
                </button>
                <div className="photo_gallery_damage_info">
                  <span>
                    Tap <img src={iconPoint} alt="tab icon" width="16" /> to see{' '}
                    {prepareDamagesDescription(mainSlide?.damages)}
                  </span>
                </div>
              </>
            )}
          <button
            type="button"
            onClick={() => {
              if (allMedia.length > 0) {
                const photosForPopup = images?.filter((it) => it?.id) || [];
                const videosForPopup = videos?.filter((it) => it?.fileUrl) || [];
                const combined = photosForPopup.concat(videosForPopup);
                const idx = combined.findIndex((m) => m?.id === mainSlide?.id);
                setPopupInitial(idx >= 0 ? idx : 0);
                setShowPopup(true);
              }
            }}
          >
            {(() => {
              let src = mainSlide?.fileUrl;
              if (mainSlide?.type === 'video') {
                src = mainSlide?.previewUrl || mainSlide?.fileUrl;
              }
              return <img className="main-image" src={src} alt="Main" />;
            })()}
          </button>
        </div>
        <Slider
          className="common-images-slider__slider"
          {...settings}
          style={{ marginTop: '10px' }}
        >
          {allMedia.map((media, idx) => {
            let src = media?.thumbnailUrl ? media?.thumbnailUrl : media?.fileUrl;
            if (media?.type === 'video') {
              src = media?.previewUrl || media?.fileUrl;
            }
            return (
              <div className="slider__images-wrapper" key={media?.id || media?.fileUrl || idx}>
                <img className="slider__image" src={src} alt={`Media ${idx}`} />
              </div>
            );
          })}
        </Slider>
      </div>
      <SweetAlert
        custom
        show={showPopup}
        showCancel={false}
        showConfirm={false}
        onCancel={() => setShowPopup(false)}
        onConfirm={() => {}}
        title=""
        customClass="photo_gallery_popup"
      >
        <VehicleImagesPopupSlider
          photos={images}
          videos={videos}
          initial={popupInitial}
          closeHandler={() => setShowPopup(false)}
          onDamageClick={(damages) => {
            if (Array.isArray(damages) && damages.length) {
              FancyBoxNative.show(
                damages.map((image) => ({
                  src: image?.fileUrl,
                  caption: DamageTypesName?.[image?.damageType] || '',
                })),
                fancyBoxOptions,
              );
            }
          }}
        />
      </SweetAlert>
      <FancyBoxHiddenGallery media={allMedia} group="gallery" />
    </>
  );
}

export default ImageSlider;
